import { useUserPreferences} from "@twigsby/client-data";
import {
    Card,
    CardLayoutType, ContentBlock,
    ContentLoader, FlexAlign,
    FlexGap, FlexJustify,
    StackHorizontal,
    StackVertical
} from "@twigsby/frontend-framework";
import {FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {AutoForwarding} from "../../../Components/Account/Components/AutoForwarding";
import UserAction from "../../../Components/Settings/Controls/UserAction";
import {SettingsActionType} from "../../../Components/Settings/SettingsTypes";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

type UserPreferencesType = {
    userActions: Array<SettingsActionType>;
}

const Preferences = () => {
    const{ t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();
    const formMethods = useForm();

    const {
        status,
        data,
        error,
    } : {
        status: any,
        data: any | UserPreferencesType,
        error: any,
        isFetching: any
    } = useUserPreferences();

    useEffect(() => {
        updatePageMeta({
            title: t('settings.preferences.title')
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-md'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Preferences"}`)}</h2>
            </StackHorizontal>

            <FormProvider {...formMethods}>
                <StackVertical gap={FlexGap.ExtraLarge}>
                    <div>
                        <Card headerOptions={{ title: t('labels.general')}} type={CardLayoutType.SlimHeader} emptyBody={true}>
                            {status === "loading" ? (
                                <ContentLoader childHeight={'6em'} childCount={6} />
                            ) : status === "error" ? (
                                <ContentBlock error={true} title={error.name} content={error.message} />
                            ) : (
                                <>
                                    {data && data.userActions.map((item: SettingsActionType, index: number) => <UserAction {...item} key={`preferencesUserAction${index}`} /> )}
                                </>
                            )}
                        </Card>
                    </div>

                    <div>
                        <AutoForwarding />
                    </div>
                </StackVertical>
            </FormProvider>
        </>
    )
}

export default Preferences
